import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsAndConditions = () => {
  const navigate = useNavigate();
  
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg my-10">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Terms and Conditions</h1>
        <button
          onClick={() => navigate(-1)}
          className="bg-squadtrip hover:bg-squadtrip-dark text-white px-4 py-2 rounded transition-colors"
        >
          Back
        </button>
      </div>
      
      <div className="prose prose-lg max-w-none">
        <p className="text-gray-600 mb-6">
          Last Updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
        </p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">1. Acceptance of Terms</h2>
        <p>
          By accessing or using the SquadTrip Saver application ("the Service"), you agree to be bound by these Terms and Conditions ("Terms"). If you do not agree to all of these Terms, you may not use the Service.
        </p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">2. Description of Service</h2>
        <p>
          SquadTrip Saver is a financial savings application that helps users save for travel and vacations through automated recurring payments. The Service enables users to set savings goals, track progress, and manage their travel funds.
        </p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">3. Registration and User Accounts</h2>
        <p>
          When you register to use the Service, you agree to provide accurate, current, and complete information. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
        </p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">4. Payment Terms</h2>
        <p>
          By using the Service, you authorize us to charge your designated payment method for the recurring savings amount you select, plus any applicable fees as disclosed during the signup process. Payment processing is handled by Stripe, and you agree to Stripe's terms of service when making payments through our Service.
        </p>
        <p>
          A 5% service fee is added to each savings contribution. This fee covers payment processing costs and platform maintenance.
        </p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">5. Disclaimer of Warranties</h2>
        <p className="font-bold">
          THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE EXPLICITLY DISCLAIM ALL WARRANTIES, INCLUDING ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
        </p>
        <p>
          We do not guarantee that the Service will always be secure, error-free, or available. We do not warrant that any information provided through the Service is accurate, complete, or useful.
        </p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">6. Limitation of Liability</h2>
        <p className="font-bold">
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL SQUADTRIP SAVER, ITS OWNERS, EMPLOYEES, PARTNERS, OR SUPPLIERS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION, LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM:
        </p>
        <ul className="list-disc pl-8 mt-2 mb-4">
          <li>YOUR ACCESS TO OR USE OF OR INABILITY TO ACCESS OR USE THE SERVICE;</li>
          <li>ANY CONDUCT OR CONTENT OF ANY THIRD PARTY ON THE SERVICE;</li>
          <li>ANY CONTENT OBTAINED FROM THE SERVICE; AND</li>
          <li>UNAUTHORIZED ACCESS, USE, OR ALTERATION OF YOUR TRANSMISSIONS OR CONTENT</li>
        </ul>
        <p className="font-bold">
          OUR TOTAL LIABILITY TO YOU FOR ANY DAMAGES SHALL NOT EXCEED THE AMOUNT YOU HAVE PAID TO US IN SERVICE FEES DURING THE SIX (6) MONTHS PRECEDING THE EVENT GIVING RISE TO THE LIABILITY.
        </p>
        <p>
          WE ARE NOT RESPONSIBLE FOR ANY FINANCIAL DECISIONS YOU MAKE BASED ON THE SERVICE OR FOR YOUR ABILITY TO MEET SAVINGS GOALS. THE SERVICE DOES NOT PROVIDE FINANCIAL ADVICE.
        </p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">7. Indemnification</h2>
        <p>
          You agree to defend, indemnify, and hold harmless SquadTrip Saver and its owners, employees, contractors, agents, officers, and directors from and against any and all claims, damages, obligations, losses, liabilities, costs, or debt, and expenses (including but not limited to attorney's fees) arising from:
        </p>
        <ul className="list-disc pl-8 mt-2 mb-4">
          <li>Your use of and access to the Service;</li>
          <li>Your violation of any term of these Terms;</li>
          <li>Your violation of any third-party right, including without limitation any copyright, property, or privacy right;</li>
          <li>Any claim that your actions caused damage to a third party.</li>
        </ul>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">8. Termination</h2>
        <p>
          We may terminate or suspend your account and access to the Service immediately, without prior notice or liability, for any reason whatsoever, including, without limitation, if you breach these Terms.
        </p>
        <p>
          You may cancel your subscription at any time by contacting us. Upon cancellation, your subscription will remain active until the end of your current billing period. No refunds will be issued for partially used subscription periods.
        </p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">9. Changes to Terms</h2>
        <p>
          We reserve the right to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
        </p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">10. Contact Information</h2>
        <p>
          If you have any questions about these Terms, please contact us at:
          <br />
          <a href="mailto:support@squadtrip.com" className="text-squadtrip hover:underline">support@squadtrip.com</a>
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;